import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=8e53f8bc&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=8e53f8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e53f8bc",
  null
  
)

export default component.exports
import {QIcon,QBtn,QDialog,QCard,QCardSection,QSpace,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QBtn,QDialog,QCard,QCardSection,QSpace,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
